<template>
  <ExpandableCard v-if="systemMaintenance">
    <span class="text-center text-h6 col">{{ systemMaintenance.header }}</span>

    <template #dropdown>
      {{ systemMaintenance.details }}
    </template>
  </ExpandableCard>
</template>

<script setup lang="ts">
import { useStore } from "@/store";
import ExpandableCard from "./ExpandableCard.vue";
import { computed } from "vue";
const store = useStore();
const systemMaintenance = computed(
  () => store.state.systemSetting?.systemNotification
);
</script>
